//Editor
import * as VueRouter from 'vue-router';
import {
    DesignPanelPathsEnum,
    DesignPanelTypesEnum, PagesPanelPathsEnum,
    PagesPanelTypesEnum,
    SettingsPanelPathsEnum,
    SettingsPanelTypesEnum
} from "../common/enums.js";

// page components
const PortfolioEditor = () => import(/* webpackChunkName: "editor-pages" */ '../portfolioEditor/PortfolioEditor.vue')
const HomePage = () => import(/* webpackChunkName: "editor-pages" */ '../portfolioEditor/pages/HomePage.vue')
const AboutPage = () => import(/* webpackChunkName: "editor-pages" */ '../portfolioEditor/pages/AboutPage.vue')
const ContactPage = () => import(/* webpackChunkName: "editor-pages" */ '../portfolioEditor/pages/ContactPage.vue')
const CustomPage = () => import(/* webpackChunkName: "editor-pages" */ '../portfolioEditor/pages/CustomPage.vue')
const OnBoardingPage = () => import(/* webpackChunkName: "editor-pages" */ '../portfolioManager/OnBoardingPage.vue')
const NotificationsPage = () => import(/* webpackChunkName: "editor-pages" */ '../nonEditorPages/NotificationsPage.vue')
const AccountSettingsPage = () => import(/* webpackChunkName: "editor-pages" */ '../nonEditorPages/accountSettings/AccountSettingsPage.vue')
const PortfolioManagerPage = () => import(/* webpackChunkName: "editor-pages" */ '../portfolioManager/PortfolioManagerPage.vue')
const PaymentApp = () => import(/* webpackChunkName: "editor-pages" */ '../paymentCenter/PaymentApp.vue')
const Prices = () => import(/* webpackChunkName: "editor-pages" */ '../nonEditorPages/Prices.vue')


//Account settings pages
const AccountSettingsSubPage = () => import(/* webpackChunkName: "account-settings-sub-pages" */ '../nonEditorPages/accountSettings/subPages/AccountSettingsSubPage.vue');
const DomainsSubPage = () => import(/* webpackChunkName: "account-settings-sub-pages" */ '../nonEditorPages/accountSettings/subPages/DomainsSubPage.vue');
const PlanAndPaymentSubPage = () => import(/* webpackChunkName: "account-settings-sub-pages" */ '../nonEditorPages/accountSettings/subPages/PlanAndPaymentSubPage.vue');
const PortfolioSettingsSubPage = () => import(/* webpackChunkName: "account-settings-sub-pages" */ '../nonEditorPages/accountSettings/subPages/PortfolioSettingsSubPage.vue');

// portfolio manager and template selector components
const PortfoliosList = () => import(/* webpackChunkName: "template-selector-pages" */ '../portfolioManager/portfolioManager/PortfoliosList.vue')
const AllProjectsList = () => import(/* webpackChunkName: "template-selector-pages" */ '../portfolioManager/portfolioManager/ProjectsList.vue')
const TemplateList = () => import(/* webpackChunkName: "template-selector-pages" */ '../portfolioManager/portfolioManager/TemplateList.vue')
const TemplatePreview = () => import(/* webpackChunkName: "template-selector-pages" */'../portfolioManager/portfolioManager/TemplatePreview.vue')


// design panels
const DesignPanel = () => import(/* webpackChunkName: "design-panel" */ '../common/sideBars/Design.vue')
const DesignMainPanel = () => import(/* webpackChunkName: "design-panel" */ '../common/sideBars/design/_DesignMainPanel.vue')
const Templates = () => import(/* webpackChunkName: "design-panel" */ '../common/sideBars/design/Templates.vue')
const Colors = () => import(/* webpackChunkName: "design-panel" */ '../common/sideBars/design/Colors.vue')
const AdvancedColorStyles = () => import(/* webpackChunkName: "design-panel" */ '../common/sideBars/design/AdvancedColorStyles.vue')
const ColorPaletteEdit = () => import(/* webpackChunkName: "design-panel" */ '../common/sideBars/design/ColorPaletteEditor.vue')
const TextStyles = () => import(/* webpackChunkName: "design-panel" */ '../common/sideBars/design/Fonts.vue')
const AdvancedTextStyles = () => import(/* webpackChunkName: "design-panel" */ '../common/sideBars/design/AdvancedTextStyles.vue')
const Buttons = () => import(/* webpackChunkName: "design-panel" */ '../common/sideBars/design/Buttons.vue')
const Cursor = () => import(/* webpackChunkName: "design-panel" */ '../common/sideBars/design/Cursor.vue')
const AdvancedButtonSettings = () => import(/* webpackChunkName: "design-panel" */ '../common/sideBars/design/AdvancedButtonSettings.vue')
const LabelSettings = () => import(/* webpackChunkName: "design-panel" */ '../common/sideBars/design/LabelSettings.vue')
const SocialIconSettings = () => import(/* webpackChunkName: "design-panel" */ '../common/sideBars/design/SocialIconSettings.vue')
const Animations = () => import(/* webpackChunkName: "design-panel" */ '../common/sideBars/design/Animations.vue')
const Spacing = () => import(/* webpackChunkName: "design-panel" */'../common/sideBars/design/Spacing.vue')
const SiteMargin = () => import(/* webpackChunkName: "design-panel" */'../common/sideBars/design/SiteMargin.vue')

// settings panels
const SettingsPanel = () => import(/* webpackChunkName: "settings-panel" */ '../common/sideBars/Settings.vue')
const SettingsMainPanel = () => import(/* webpackChunkName: "settings-panel" */ '../common/sideBars/settings/_SettingsMainPanel.vue')
const SocialMediaLinks = () => import(/* webpackChunkName: "settings-panel" */ '../common/sideBars/settings/SocialMediaLinks.vue')
const SocialLinkEdit = () => import(/* webpackChunkName: "settings-panel" */ '../common/sideBars/settings/EditSocialLink.vue')
const PortfolioLogo = () => import(/* webpackChunkName: "settings-panel" */ '../common/sideBars/settings/PortfolioLogo.vue')
const Favicon = () => import(/* webpackChunkName: "settings-panel" */ '../common/sideBars/settings/Favicon.vue')

// pages panels
const PagesPanel = () => import(/* webpackChunkName: "pages-panel" */ '../common/sideBars/Pages.vue')
const AddNewPage = () => import(/* webpackChunkName: "settings-panel" */ '../common/sideBars/pages/AddNewPage.vue')
const ExternalLinkEdit = () => import(/* webpackChunkName: "settings-panel" */ '../common/sideBars/pages/EditExternalLink.vue')
const ResumeEdit = () => import(/* webpackChunkName: "settings-panel" */ '../common/sideBars/pages/EditFile.vue')


import MailtoLinkEdit from "../common/sideBars/pages/EditMailtoLink.vue";
import PageWrapper from "../view/portfolio/PageWrapper.vue";
import PortfolioWrapper from "../view/portfolio/PortfolioWrapper.vue";
import ReviewWrapper from "../view/review/ReviewWrapper.vue";
import JFCWrapper from "../view/jobFitChecker/JFCWrapper.vue";
import OnboardingTemplatePreview from "@/scripts/portfolioManager/onboarding/OnboardingTemplatePreview.vue";
import Cursors from "@/scripts/common/sideBars/design/Cursors.vue";
import {publishAuthStatus} from "@/scripts/auth/authStatus.js";
import {getLastAuthCheckResult, initAuth, isAuthCallbackUrl, keycloak, login, requiresAuthentication, resetAuthState, sanitizeAuthRedirect} from "@/scripts/auth/keycloakAuth.js";
import {requireAdminAccess} from "@/scripts/router/adminAccessGuard.js";

const Share = () => import(/* webpackChunkName: "settings-panel" */ '../common/sideBars/settings/Share.vue')
const DomainAndUrl = () => import(/* webpackChunkName: "settings-panel" */ '../common/sideBars/settings/DomainAndUrl.vue')
const PortfolioUrl = () => import(/* webpackChunkName: "settings-panel" */ '../common/sideBars/settings/PortfolioUrl.vue')
const CaseStudyUrl = () => import(/* webpackChunkName: "settings-panel" */ '../common/sideBars/settings/CaseStudyUrl.vue')
const Archive = () => import(/* webpackChunkName: "settings-panel" */ '../common/sideBars/settings/Archive.vue')
const PasswordProtection = () => import(/* webpackChunkName: "settings-panel" */ '../common/sideBars/settings/PasswordProtection.vue')
const ThumbnailSettings = () => import(/* webpackChunkName: "settings-panel" */'../common/sideBars/settings/ThumbnailSettings.vue')
const HeaderFooter = () => import(/* webpackChunkName: "settings-panel" */ '../common/sideBars/settings/HeaderFooter.vue')

//payment pages
const PaymentSuccess = () => import(/* webpackChunkName: "payment-pages" */ '../paymentCenter/components/feedbackPages/PaymentSuccess.vue')
const PaymentCenter = () => import(/* webpackChunkName: "payment-pages" */ '../paymentCenter/PaymentCenter.vue')
const PaymentFailure = () => import(/* webpackChunkName: "payment-pages" */ '../paymentCenter/components/feedbackPages/PaymentFailure.vue')
const PaymentSecondaryAuth = () => import(/* webpackChunkName: "payment-pages" */ '../paymentCenter/PaymentSecondaryAuth.vue')
const CardDeleted = () => import(/* webpackChunkName: "payment-pages" */ '../paymentCenter/components/feedbackPages/CardDeleted.vue')

// domain related pages
const DomainCenter = () => import(/* webpackChunkName: "domain-pages" */ '../domainCenter/DomainCenter.vue')
const DomainApp = () => import(/* webpackChunkName: "domain-pages" */ '../domainCenter/DomainApp.vue')
const DomainSearch = () => import(/* webpackChunkName: "domain-pages" */ '../domainCenter/components/DomainSearch.vue')
const ConnectDomain = () => import(/* webpackChunkName: "domain-pages" */ '../domainCenter/components/ConnectDomain.vue')
const DomainTransfer = () => import(/* webpackChunkName: "domain-pages" */ '../domainCenter/components/DomainTransfer.vue')

// url related pages
const UrlCenter = () => import(/* webpackChunkName: "url-pages" */ '../urlCenter/UrlCenter.vue')
const EditUrl = () => import(/* webpackChunkName: "url-pages" */ '../urlCenter/EditUrl.vue')
const NotFound = () => import(/* webpackChunkName: "url-pages" */ '../common/404.vue')

//Public Pages
const Index = () => import(/* webpackChunkName: "public-pages" */ '../view/Index.vue')
const IndexLab = () => import(/* webpackChunkName: "public-pages" */ '../view/IndexLab.vue')
const IndexWrapper = () => import(/* webpackChunkName: "public-pages" */ '../view/portfolio/LandingWrapper.vue')
const Pricing = () => import(/* webpackChunkName: "public-pages" */ '../view/publicPages/Pricing.vue')
const ExamplesPage = () => import(/* webpackChunkName: "public-pages" */ '../view/publicPages/ExamplesPage.vue')
const ExampleFullPage = () => import(/* webpackChunkName: "public-pages" */ '../view/publicPages/ExampleFullPage.vue')
const EduPartnership = () => import(/* webpackChunkName: "public-pages" */ '../view/publicPages/EduPartnership.vue')
const PrivacyPolicy = () => import(/* webpackChunkName: "public-pages" */ '../view/publicPages/PrivacyPolicy.vue')
const TermsAndConditions = () => import(/* webpackChunkName: "public-pages" */ '../view/publicPages/TermsAndConditions.vue')
const PortfolioGeneratorTerms = () => import(/* webpackChunkName: "public-pages" */ '../view/publicPages/PortfolioGeneratorTerms.vue')
const Imprint = () => import(/* webpackChunkName: "public-pages" */ '../view/publicPages/Imprint.vue')
const ReviewSubmitPage = () => import(/* webpackChunkName: "public-pages" */ '../view/publicPages/ReviewSubmitPage.vue')
const AuthLayout = () => import(/* webpackChunkName: "auth-pages" */ '../view/auth/AuthLayout.vue')
const LoginPage = () => import(/* webpackChunkName: "auth-pages" */ '../view/auth/LoginPage.vue')
const SignupPage = () => import(/* webpackChunkName: "auth-pages" */ '../view/auth/SignupPage.vue')
const ForgotPasswordPage = () => import(/* webpackChunkName: "auth-pages" */ '../view/auth/ForgotPasswordPage.vue')
const ResetPasswordPage = () => import(/* webpackChunkName: "auth-pages" */ '../view/auth/ResetPasswordPage.vue')


//Settings Pages
const SettingsEditor = () => import(/* webpackChunkName: "settings" */ '../settingsEditor/SettingsEditor.vue')
const CopySettings = () => import(/* webpackChunkName: "settings" */ '../settingsEditor/views/EditCopyIdeas.vue')
const ImageIdeasSettings = () => import(/* webpackChunkName: "settings" */ '../settingsEditor/views/EditImageIdeas.vue')
const EditFontView = () => import(/* webpackChunkName: "settings" */ '../settingsEditor/views/EditFontView.vue')
const EditSurveyModalSettings = () => import(/* webpackChunkName: "settings" */  "../settingsEditor/views/EditSurveyModalSettings.vue");
const SpamFilterSettings = () => import(/* webpackChunkName: "settings" */ "../settingsEditor/views/EditSpamFilterSettings.vue")


//Admin page
const AdminSite = () => import(/* webpackChunkName: "admin" */ '../adminSite/AdminSite.vue')
const AdminUsers = () => import(/* webpackChunkName: "admin" */ '../adminSite/components/UserListComponent.vue')
const AdminShowcase = () => import(/* webpackChunkName: "admin" */ '../adminSite/components/ShowcaseComponent.vue')
const AdminSubscriptionReport = () => import(/* webpackChunkName: "admin" */ '../adminSite/components/SubscriptionReportComponent.vue')
const AdminOwnDomain = () => import(/* webpackChunkName: "admin" */ '../adminSite/components/OwnDomainComponent.vue')
const AdminCancelReason = () => import(/* webpackChunkName: "admin" */ '../adminSite/components/CancelReasonComponent.vue')
const AdminSurveyResponses = () => import(/* webpackChunkName: "admin" */ '../adminSite/components/SurveyResponsesComponent.vue')
const AdminSystemNotifications = () => import(/* webpackChunkName: "admin" */ '../adminSite/components/SystemNotificationsComponent.vue')
const AdminReferals = () => import(/* webpackChunkName: "admin" */ '../adminSite/components/ReferalsComponent.vue')
const AdminReviews = () => import(/* webpackChunkName: "admin" */ '../adminSite/components/ReviewsComponent.vue')
const AdminAiSettings = () => import(/* webpackChunkName: "admin" */ '../adminSite/components/AiSettingsComponent.vue')
const AdminSpamDeletion = () => import(/* webpackChunkName: "admin" */ '../adminSite/components/SpamDeletionComponent.vue')
const AdminEmergencyBanner = () => import(/* webpackChunkName: "admin" */ '../adminSite/components/EmergencyBannerControlsComponent.vue')
const AdminBackgroundLibrary = () => import(/* webpackChunkName: "admin" */ '../adminSite/components/ThumbnailBackgroundsComponent.vue')
const AdminColorPalettes = () => import(/* webpackChunkName: "admin" */ '../adminSite/components/ColorPalettesComponent.vue')
const AdminSectionPresetGroups = () => import(/* webpackChunkName: "admin" */ '../adminSite/components/SectionPresetGroupsComponent.vue')
const AdminAiGenerationTraces = () => import(/* webpackChunkName: "admin" */ '../adminSite/components/AiGenerationTraceComponent.vue')
const AdminAiPortfolioGeneratorV2 = () => import(/* webpackChunkName: "admin" */ '../adminSite/aiPortfolioGenerator/AiPortfolioGeneratorPageV2.vue')
const FigmaOAuthCallback = () => import(/* webpackChunkName: "figma-oauth" */ '../auth/FigmaOAuthCallback.vue')

function createColorPaletteEditRoute(goBackPath) {
    return {
        path: 'edit-color-palette',
        components: { sidePanelOverlayView: ColorPaletteEdit },
        meta: {
            sidePanelSettings: {
                panel: DesignPanelTypesEnum.EDIT_COLOR_PALETTE,
                title: "Edit color palette",
                goBackPath: goBackPath,
                tabPills: [
                    {
                        label: 'Edit',
                        type: 'paletteEditor'
                    },
                    {
                        label: 'Generate',
                        type: 'paletteGenerator'
                    }
                ],
                activeTab: 'paletteEditor'
            }
        }
    };
}

const designPanelRoutes =  {
    path: 'style',
    components: {sidePanel: DesignPanel},
    props: true,
    children: [
        {
            path: '',
            components: {sidePanelSubView: DesignMainPanel},
            meta: {
                sidePanelSettings: {
                    panel: DesignPanelTypesEnum.MAIN_PANEL,
                    title: 'Design',
                    saveButtonLabel: 'Save',
                    previousSettings: null,
                    prevAccentColor: null,
                    showSecondaryTab: false,
                    hideActionButtons: true,
                    hideBackButton: true,
                    allowSave: false,
                    updateParentPortfolio: false,
                    tabPills: null,
                    activeTab: null,
                    currentPanelPath: null
                }
            }
        },
        {
            path: 'change-template',
            components: {sidePanelSubView: Templates},
            meta: {
                sidebarSettings: {
                    panel: DesignPanelTypesEnum.TEMPLATES,
                    title: 'Templates',
                    hideBackButton: false,
                    hideActionButtons: false
                }
            }
        },
        {
            path: 'colors',
            components: {sidePanelSubView: Colors},
            meta: {
                sidePanelSettings: {
                    panel: DesignPanelTypesEnum.COLORS,
                    title: 'Colors',
                    hideBackButton: false,
                    hideActionButtons: false,
                    currentPanelPath: null,
                    tabPills: [
                        {
                            label: 'Presets',
                            type: 'presets'
                        },
                        {
                            label: 'Custom',
                            type: 'custom'
                        }
                    ]
                }
            },
            children: [
                {
                    path: 'heading-colors',
                    components: {sidePanelOverlayView: AdvancedColorStyles},
                    meta: {
                        sidePanelSettings: {
                            panel: DesignPanelTypesEnum.ADVANCED_HEADING_COLOR_SETTINGS,
                            title: "Edit headings",
                            goBackPath: `/${DesignPanelTypesEnum.COLORS}`
                        }
                    }
                },
                {
                    path: 'paragraph-colors',
                    components: {sidePanelOverlayView: AdvancedColorStyles},
                    meta: {
                        sidePanelSettings: {
                            panel: DesignPanelTypesEnum.ADVANCED_PARAGRAPH_COLOR_SETTINGS,
                            title: "Edit paragraphs",
                            goBackPath: `/${DesignPanelTypesEnum.COLORS}`
                        }
                    }
                },
                {
                    path: 'navigation-colors',
                    components: {sidePanelOverlayView: AdvancedColorStyles},
                    meta: {
                        sidePanelSettings: {
                            panel: DesignPanelTypesEnum.ADVANCED_NAVIGATION_COLOR_SETTINGS,
                            title: "Edit navigation",
                            goBackPath: `/${DesignPanelTypesEnum.COLORS}`
                        }
                    }
                },
                {
                    path: 'button-colors',
                    components: {sidePanelOverlayView: AdvancedColorStyles},
                    meta: {
                        sidePanelSettings: {
                            panel: DesignPanelTypesEnum.ADVANCED_BUTTON_COLOR_SETTINGS,
                            title: "Edit buttons",
                            goBackPath: `/${DesignPanelTypesEnum.COLORS}`
                        }
                    }
                },
                {
                    path: 'label-colors',
                    components: {sidePanelOverlayView: AdvancedColorStyles},
                    meta: {
                        sidePanelSettings: {
                            panel: DesignPanelTypesEnum.ADVANCED_LABEL_COLOR_SETTINGS,
                            title: "Edit labels",
                            goBackPath: `/${DesignPanelTypesEnum.COLORS}`
                        }
                    }
                },
                {
                    path: 'contact-form-colors',
                    components: {sidePanelOverlayView: AdvancedColorStyles},
                    meta: {
                        sidePanelSettings: {
                            panel: DesignPanelTypesEnum.ADVANCED_CONTACT_FORM_COLOR_SETTINGS,
                            title: "Edit contact forms",
                            goBackPath: `/${DesignPanelTypesEnum.COLORS}`
                        }
                    }
                },
                {
                    path: 'social-icon-colors',
                    components: {sidePanelOverlayView: AdvancedColorStyles},
                    meta: {
                        sidePanelSettings: {
                            panel: DesignPanelTypesEnum.ADVANCED_SOCIAL_ICON_COLOR_SETTINGS,
                            title: "Edit social icons",
                            goBackPath: `/${DesignPanelTypesEnum.COLORS}`
                        }
                    }
                },
                {
                    path: 'process-step-colors',
                    components: {sidePanelOverlayView: AdvancedColorStyles},
                    meta: {
                        sidePanelSettings: {
                            panel: DesignPanelTypesEnum.ADVANCED_PROCESS_STEP_COLOR_SETTINGS,
                            title: "Edit process steps",
                            goBackPath: `/${DesignPanelTypesEnum.COLORS}`
                        }
                    }
                },
                {
                    path: 'backgrounds',
                    components: {sidePanelOverlayView: AdvancedColorStyles},
                    meta: {
                        sidePanelSettings: {
                            panel: DesignPanelTypesEnum.ADVANCED_BACKGROUND_COLOR_SETTINGS,
                            title: "Edit backgrounds",
                            goBackPath: `/${DesignPanelTypesEnum.COLORS}`
                        }
                    }
                },
                createColorPaletteEditRoute(`/${DesignPanelTypesEnum.COLORS}`),
            ]
        },
        {
            path: 'fonts',
            components: {sidePanelSubView: TextStyles},
            meta: {
                sidePanelSettings: {
                    panel: DesignPanelTypesEnum.FONTS,
                    title: 'Fonts',
                    hideBackButton: false,
                    hideActionButtons: false,
                    currentPanelPath: DesignPanelPathsEnum.FONTS,
                    tabPills: [
                        {
                            label: 'Presets',
                            type: 'presets'
                        },
                        {
                            label: 'Custom',
                            type: 'custom'
                        }
                    ],
                    activeTab: 'custom'
                }
            },
            children: [
                {
                    path: 'headings',
                    components: {sidePanelOverlayView: AdvancedTextStyles},
                    meta: {
                        sidePanelSettings: {
                            panel: DesignPanelTypesEnum.ADVANCED_HEADING_STYLE_SETTINGS,
                            title: "Edit headings",
                            goBackPath: `/${DesignPanelTypesEnum.FONTS}`
                        }
                    }
                },
                {
                    path: 'paragraphs',
                    components: {sidePanelOverlayView: AdvancedTextStyles},
                    meta: {
                        sidePanelSettings: {
                            panel: DesignPanelTypesEnum.ADVANCED_PARAGRAPH_STYLE_SETTINGS,
                            title: "Edit paragraphs",
                            goBackPath: `/${DesignPanelTypesEnum.FONTS}`
                        }
                    }
                },
                {
                    path: 'navigation-buttons',
                    components: {sidePanelOverlayView: AdvancedTextStyles},
                    meta: {
                        sidePanelSettings: {
                            panel: DesignPanelTypesEnum.ADVANCED_NAVIGATION_STYLE_SETTINGS,
                            title: "Edit navigation",
                            goBackPath: `/${DesignPanelTypesEnum.FONTS}`
                        }
                    }
                },
                {
                    path: 'buttons',
                    components: {sidePanelOverlayView: AdvancedTextStyles},
                    meta: {
                        sidePanelSettings: {
                            panel: DesignPanelTypesEnum.ADVANCED_BUTTON_STYLE_SETTINGS,
                            title: "Edit button labels",
                            goBackPath: `/${DesignPanelTypesEnum.FONTS}`
                        }
                    }
                },
                createColorPaletteEditRoute(`/${DesignPanelTypesEnum.FONTS}`),
            ]
        },
        {
            path: 'button-settings',
            components: {sidePanelSubView: Buttons},
            meta: {
                sidePanelSettings: {
                    panel: DesignPanelTypesEnum.BUTTONS,
                    title: 'Buttons',
                    hideBackButton: false,
                    hideActionButtons: true,
                    currentPanelPath: DesignPanelPathsEnum.BUTTON_SETTINGS,
                }
            },
            children: [
                {
                    path: 'advanced-button-settings',
                    components: {sidePanelOverlayView: AdvancedButtonSettings},
                    meta: {
                        sidePanelSettings: {
                            panel: DesignPanelTypesEnum.ADVANCED_BUTTON_SETTINGS,
                            title: "Edit buttons",
                            hideActionButtons: false,
                            goBackPath: `/${DesignPanelPathsEnum.BUTTON_SETTINGS}`
                        }
                    }
                },
                {
                    path: 'button-colors',
                    components: {sidePanelOverlayView: AdvancedColorStyles},
                    meta: {
                        sidePanelSettings: {
                            panel: DesignPanelTypesEnum.ADVANCED_BUTTON_COLOR_SETTINGS,
                            title: "Edit buttons",
                            goBackPath: `/${DesignPanelPathsEnum.BUTTON_SETTINGS}/${DesignPanelPathsEnum.ADVANCED_BUTTON_SETTINGS}`
                        }
                    }
                },
                createColorPaletteEditRoute(`/${DesignPanelPathsEnum.BUTTON_SETTINGS}`),
            ]
        },
        {
            path: 'cursor-settings',
            components: {sidePanelSubView: Cursors},
            meta: {
                sidePanelSettings: {
                    panel: DesignPanelTypesEnum.CURSORS,
                    title: "Cursor",
                    hideBackButton: false,
                    hideActionButtons: false,
                }
            }
        },
        {
            path: 'label-settings',
            components: {sidePanelSubView: LabelSettings},
            meta: {
                sidePanelSettings: {
                    panel: DesignPanelTypesEnum.LABELS,
                    title: 'Labels',
                    hideBackButton: false,
                    hideActionButtons: false,
                    currentPanelPath: DesignPanelPathsEnum.LABEL_SETTINGS,
                }
            },
            children: [
                {
                    path: 'label-colors',
                    components: {sidePanelOverlayView: AdvancedColorStyles},
                    meta: {
                        sidePanelSettings: {
                            panel: DesignPanelTypesEnum.ADVANCED_LABEL_COLOR_SETTINGS,
                            title: "Edit labels",
                            goBackPath: `/${DesignPanelPathsEnum.LABEL_SETTINGS}`
                        }
                    }
                },
                createColorPaletteEditRoute(`/${DesignPanelPathsEnum.LABEL_SETTINGS}`),
            ]
        },
        {
            path: 'social-icon-settings',
            components: {sidePanelSubView: SocialIconSettings},
            meta: {
                sidePanelSettings: {
                    panel: DesignPanelTypesEnum.SOCIAL_ICON_SETTINGS,
                    title: 'Social icons',
                    hideBackButton: false,
                    hideActionButtons: false,
                    currentPanelPath: DesignPanelPathsEnum.SOCIAL_ICON_SETTINGS,
                }
            },
            children: [
                {
                    path: 'social-icon-colors',
                    components: {sidePanelOverlayView: AdvancedColorStyles},
                    meta: {
                        sidePanelSettings: {
                            panel: DesignPanelTypesEnum.ADVANCED_SOCIAL_ICON_COLOR_SETTINGS,
                            title: "Edit social icon",
                            goBackPath: `/${DesignPanelPathsEnum.SOCIAL_ICON_SETTINGS}`
                        }
                    }
                },
            ]
        },
        {
            path: 'animation-settings',
            components: {sidePanelSubView: Animations},
            meta: {
                sidePanelSettings: {
                    panel: DesignPanelTypesEnum.ANIMATION_SETTINGS,
                    title: 'Animations',
                    hideBackButton: false,
                    hideActionButtons: false
                }
            }
        },
        {
            path: 'spacing',
            components: {sidePanelSubView: Spacing},
            meta: {
                sidePanelSettings: {
                    panel: DesignPanelTypesEnum.SPACING,
                    title: 'Section spacing',
                    hideBackButton: false,
                    hideActionButtons: false
                }
            }
        },
        {
            path: 'site-margin',
            components: {sidePanelSubView: SiteMargin},
            meta: {
                sidePanelSettings: {
                    panel: DesignPanelTypesEnum.SITE_MARGIN,
                    title: 'Site margin',
                    hideBackButton: false,
                    hideActionButtons: false
                }
            }
        }
    ]
};

const settingsPanelRoutes = {
    path: 'settings',
    components: {sidePanel: SettingsPanel},
    props: true,
    children: [
        {
            path: '',
            components: {sidePanelSubView: SettingsMainPanel},
            meta: {
                sidePanelSettings: {
                    panel: SettingsPanelTypesEnum.MAIN_PANEL,
                    title: 'Settings',
                    previousSettings: null,
                    prevAccentColor: null,
                    saveButton: 'Save',
                    showSecondaryTab: false,
                    hideActionButtons: true,
                    hideBackButton: true,
                    allowSave: false,
                    tabPills: null,
                    activeTab: null
                }
            }
        },
        {
            path: 'social-media-links',
            components: {sidePanelSubView: SocialMediaLinks},
            meta: {
                sidePanelSettings: {
                    panel: SettingsPanelTypesEnum.SOCIAL_MEDIA_LINKS,
                    title: 'Social media links',
                    hideActionButtons: true,
                    hideBackButton: false,
                }
            },
            children: [
                {
                    path: 'add-social-link',
                    components: {sidePanelOverlayView: SocialLinkEdit},
                    meta: {
                        sidePanelSettings: {
                            panel: SettingsPanelTypesEnum.EDIT_SOCIAL_LINKS,
                            title: 'Add social link',
                            hideActionButtons: false,
                            goBackPath: `/${SettingsPanelPathsEnum.SOCIAL_MEDIA_LINKS}`
                        }
                    }
                },
                {
                    path: 'edit-social-link',
                    components: {sidePanelOverlayView: SocialLinkEdit},
                    meta: {
                        sidePanelSettings: {
                            panel: SettingsPanelTypesEnum.EDIT_SOCIAL_LINKS,
                            title: 'Edit social link',
                            hideActionButtons: false,
                            goBackPath: `/${SettingsPanelPathsEnum.SOCIAL_MEDIA_LINKS}`
                        }
                    }
                }
            ]
        },
        {
            path: 'portfolio-logo',
            components: {sidePanelSubView: PortfolioLogo},
            meta: {
                sidePanelSettings: {
                    panel: SettingsPanelTypesEnum.PORTFOLIO_LOGO,
                    title: 'Portfolio logo',
                    hideActionButtons: false,
                    hideBackButton: false,
                }
            },
        },
        {
            path: 'share',
            components: {sidePanelSubView: Share},
            meta: {
                sidePanelSettings: {
                    panel: SettingsPanelTypesEnum.SHARE,
                    hideBackButton: false,
                    hideActionButtons: false
                }
            }
        },
        {
            path: 'domain-and-url',
            alias: 'portfolio-own-domain',
            components: {sidePanelSubView: DomainAndUrl},
            meta: {
                sidePanelSettings: {
                    panel: SettingsPanelTypesEnum.DOMAIN_AND_URL,
                    title: 'Domain & URL',
                    hideActionButtons: true,
                    hideBackButton: false
                }
            },
            children: [
                {
                    path: 'edit-url',
                    components: {sidePanelOverlayView: PortfolioUrl},
                    meta: {
                        sidePanelSettings: {
                            panel: SettingsPanelTypesEnum.URL,
                            title: 'Edit URL',
                            hideActionButtons: false,
                            hideBackButton: true,
                            saveButton: 'Save',
                        }
                    }
                }
            ]
        },
        {
            path: 'url-slug',
            alias: 'case-study-url',
            components: {sidePanelSubView: CaseStudyUrl},
            meta: {
                sidePanelSettings: {
                    panel: SettingsPanelTypesEnum.URL,
                    title: 'Case study URL',
                    hideActionButtons: false,
                    hideBackButton: false,
                    saveButton: 'Save',
                }
            }
        },
        {
            path: 'archive',
            components: {sidePanelSubView: Archive},
            meta: {
                sidePanelSettings: {
                    panel: SettingsPanelTypesEnum.ARCHIVE,
                    title: 'Archive',
                    hideActionButtons: true,
                    hideBackButton: false
                }
            }
        },
        {
            path: 'password',
            components: {sidePanelSubView: PasswordProtection},
            meta: {
                sidePanelSettings: {
                    panel: SettingsPanelTypesEnum.PASSWORD,
                    saveButton: 'Save',
                    hideActionButtons: false,
                    hideBackButton: false
                }
            }
        },
        {
            path: 'favicon',
            components: {sidePanelSubView: Favicon},
            meta: {
                sidePanelSettings: {
                    panel: SettingsPanelTypesEnum.FAVICON,
                    title: 'Favicon',
                    hideActionButtons: false,
                    hideBackButton: false
                }
            }
        },
        {
            path: 'basic-details',
            components: {sidePanelSubView: ThumbnailSettings},
            meta: {
                sidePanelSettings: {
                    panel: SettingsPanelTypesEnum.THUMBNAIL_SETTINGS,
                    title: 'Thumbnail settings',
                    hideBackButton: false,
                    hideActionButtons: false
                }
            }
        },
        {
            path: 'display-options',
            components: {sidePanelSubView: HeaderFooter},
            meta: {
                sidePanelSettings: {
                    panel: SettingsPanelTypesEnum.NAVIGATION,
                    title: 'Navigation',
                    hideBackButton: false,
                    hideActionButtons: false
                }
            }
        }
    ]
}

const pagesPanelRoutes = {
    path: 'pages',
    components: {sidePanel: PagesPanel},
    meta: {
        sidePanelSettings: {
            panel: PagesPanelTypesEnum.MAIN_PANEL,
            title: 'Pages',
            previousSettings: null,
            prevAccentColor: null,
            saveButton: 'Save',
            showSecondaryTab: false,
            hideActionButtons: true,
            hideBackButton: true,
            allowSave: false,
            tabPills: null,
            activeTab: null
        }
    },
    props: true,
    children: [
        {
            path: 'add-new-page',
            components: {sidePanelOverlayView: AddNewPage},
            meta: {
                sidePanelSettings: {
                    panel: PagesPanelTypesEnum.ADD_NEW_PAGE,
                    title: 'Add page or link',
                    hideActionButtons: true,
                    goBackPath: '/'
                }
            }
        },
        {
            path: 'external-link',
            components: {sidePanelOverlayView: ExternalLinkEdit},
            meta: {
                sidePanelSettings: {
                    panel: PagesPanelTypesEnum.NAVIGATION_EXTERNAL_LINK,
                    hideActionButtons: false,
                    goBackPath: '/'
                }
            }
        },
        {
            path: 'mailto-link',
            components: {sidePanelOverlayView: MailtoLinkEdit},
            meta: {
                sidePanelSettings: {
                    panel: PagesPanelTypesEnum.NAVIGATION_MAILTO_LINK,
                    hideActionButtons: false,
                    goBackPath: '/'
                }
            }
        },
        {
            path: 'resume',
            components: {sidePanelOverlayView: ResumeEdit},
            meta: {
                sidePanelSettings: {
                    panel: PagesPanelTypesEnum.RESUME,
                    hideActionButtons: false,
                    goBackPath: '/'
                }
            }
        }
    ]
}

const jfcRoutes = [
    {
        path: '/jobfitchecker/:portfolioShortId',
        component: JFCWrapper,
        meta: {
            type: 'jfc'
        }
    },
    {
        path: '/jobfitchecker/p/:portfolioShortId/:projectShortId',
        component: JFCWrapper,
        meta: {
            type: 'jfc'
        }
    }
]

const reviewRoutes = [
    {
        path: '/review/p/:portfolioShortId/:projectShortId',
        component: ReviewWrapper,
        props: { review: true },
        meta: {
            type: 'review'
        }
    },
    {
        path: '/review/:portfolioShortId',
        component: ReviewWrapper,
        props: { review: true },
        meta: {
            type: 'review'
        }
    },
    //Different route for reciever mode for checking and follow up
    {
        path: '/myreviews/p/:portfolioShortId/:projectShortId',
        component: ReviewWrapper,
        props: { review: false },
        meta: {
            type: 'review'
        }
    },
    {
        path: '/myreviews/:portfolioShortId',
        component: ReviewWrapper,
        props: { review: false },
        meta: {
            type: 'review'
        }
    },
]


const projectRouters = [
    {
        path: '/p/:projectShortId',
        component: PageWrapper,
        meta: {
            type: 'view'
        }
    },
    {
        path: "/p/:portfolioShortId/:projectShortId",
        alias: [
            "/portfolio/:portfolioShortId/project/:projectShortId",
        ],
        component: PageWrapper,
        meta: {
            type: 'view'
        }
    },
    {
        path:'/project/:projectShortId/:projectName',
        alias:[
            //TODO: check with Zsuzsi
            "/project/uxs-headless/:projectShortId/:projectName",                // iframe embed on uxstudioteam.com
        ],
        component: PageWrapper,
        meta: {
            type: 'view'
        }
    }
]

const portfolioGenerationPreviewRoutes = [
    {
        path: '/portfolio-generation/:generationId/preview',
        component: PortfolioWrapper,
        meta: {
            type: 'view',
            portfolioGenerationPreview: true,
        }
    },
    {
        path: '/portfolio-generation/:generationId/preview/:projectShortId',
        component: PageWrapper,
        meta: {
            type: 'view',
            portfolioGenerationPreview: true,
        }
    },
]

// The owner's draft preview (the phone editor shows it in an iframe), see keycloakAuth.isOwnerPreviewRoute
const ownerPreviewRoutes = [
    {
        path: '/preview/:shortId',
        component: PortfolioWrapper,
        meta: {
            type: 'view',
            ownerPreview: true,
        }
    },
    {
        path: '/preview/p/:portfolioShortId/:projectShortId',
        component: PageWrapper,
        meta: {
            type: 'view',
            ownerPreview: true,
        }
    },
]

const portfolioRouters = [
    {
        path: '/portfolio/:portfolioId',
        component: PortfolioWrapper,
        meta: {
            type: 'view'
        }
    },
    {
        path:"/:shortId",
        component: PortfolioWrapper,
        meta: {
            type: 'view'
        }
    },
]

const globalAndAdminRoutes = [
    {
        path:'/',
        name:'Index',
        props: true,
        component: IndexWrapper,
    },
    {
        path: '/custom-ux-portfolio',
        name: 'IndexLab',
        props: true,
        component: IndexLab,
        meta: {
            title: 'UXfolio - Build the UX portfolio that gets you hired',
            type: 'landing'
        }
    },
    {
        path:'/result',
        name:'Review Result',
        props:true,
        component:ReviewSubmitPage
    },
    {
        path: '/',
        component: AuthLayout,
        children: [
            {
                path: 'login',
                name: 'Login',
                component: LoginPage,
                meta: {
                    title: 'Log in - UXfolio',
                    type: 'landing',
                }
            },
            {
                path: 'signup',
                name: 'Signup',
                component: SignupPage,
                meta: {
                    title: 'Sign up - UXfolio',
                    type: 'landing',
                }
            },
            {
                path: 'forgot-password',
                name: 'Forgot Password',
                component: ForgotPasswordPage,
                meta: {
                    title: 'Reset password - UXfolio',
                    type: 'landing',
                }
            },
            {
                path: 'reset-password',
                name: 'Reset Password',
                component: ResetPasswordPage,
                meta: {
                    title: 'Create new password - UXfolio',
                    type: 'landing',
                }
            },
        ],
    },
    {
        path: '/pricing',
        name: 'Pricing',
        props: true,
        component: Pricing,
        meta: {
            title: 'Pricing - UXfolio',
            type: 'landing'
        }
    },
    {
        path:'/examples/:showcaseItemShortId/:showcaseItemName',
        name:'Example',
        props: true,
        component:ExampleFullPage,
        meta: {
            type: 'landing',
            title: 'Examples - UXfolio',
        }
    },
    {
        path:'/examples',
        name:'Examples',
        props: true,
        component: ExamplesPage,
        meta: {
            title: 'Examples - UXfolio',
            type: 'landing',
        }
    },
    {
        path:'/showcase',
        name:'Showcase',
        redirect: {
            name:'Examples',
        },
    },
    {
        path: '/partnership-program',
        name: 'Partnership program',
        alias: '/partnership-program/:submitFeedback',
        component: EduPartnership,
        meta: {
            title: 'Educational partnership - UXfolio',
            type: 'landing'
        }
    },
    {
        path:'/privacy-policy',
        name:'Privacy policy',
        component:PrivacyPolicy,
        meta: {
            type: 'landing',
            title: 'Privacy Policy - UXfolio'
        }
    },
    {
        path:'/terms-and-conditions',
        name: 'Terms and conditions',
        component:TermsAndConditions,
        meta: {
            type: 'landing',
            title: 'Terms and Conditions - UXfolio'
        }
    },
    {
        path:'/imprint',
        name:'Imprint',
        component: Imprint,
        meta: {
            type: 'landing',
            title: 'Imprint - UXfolio'
        }
    },
    {
        path:'/figma-oauth-callback',
        name:'figma-oauth-callback',
        component: FigmaOAuthCallback,
        meta: {
            title: 'Figma connection'
        }
    },
    {
        path:'/ai-portfolio-generator',
        name:'ai-portfolio-generator',
        redirect: to => ({
            name: 'portfolio-generator',
            query: to.query,
            hash: to.hash
        })
    },
    {
        path:'/ai-portfolio-generator/:generationId',
        name:'ai-portfolio-generator-generation',
        redirect: to => ({
            name: 'portfolio-generator-generation',
            params: { generationId: to.params.generationId },
            query: to.query,
            hash: to.hash
        })
    },
    // Flow V2: the real generation, with the questions moved behind the preview.
    {
        path:'/ux-portfolio-generator',
        name:'portfolio-generator',
        component: AdminAiPortfolioGeneratorV2,
        meta: {
            title: 'Portfolio Generator - UXfolio'
        }
    },
    // The generator's own terms, linked from its footer. A static path, so it ranks above
    // the generation route's `:generationId` below.
    {
        path:'/ux-portfolio-generator/terms-and-conditions',
        name:'portfolio-generator-terms',
        component: PortfolioGeneratorTerms,
        meta: {
            type: 'landing',
            title: 'AI Portfolio Generator Terms and Conditions - UXfolio'
        }
    },
    {
        path:'/ux-portfolio-generator/:generationId',
        name:'portfolio-generator-generation',
        component: AdminAiPortfolioGeneratorV2,
        meta: {
            title: 'Portfolio Generator - UXfolio'
        }
    },
    {
        path:'/portfolio-generator',
        redirect: to => ({
            name: 'portfolio-generator',
            query: to.query,
            hash: to.hash
        })
    },
    {
        path:'/portfolio-generator/:generationId',
        redirect: to => ({
            name: 'portfolio-generator-generation',
            params: { generationId: to.params.generationId },
            query: to.query,
            hash: to.hash
        })
    },
    {
        path:'/ai-portfolio-generator-v2',
        redirect: to => ({
            name: 'portfolio-generator',
            query: to.query,
            hash: to.hash
        })
    },
    {
        path:'/ai-portfolio-generator-v2/:generationId',
        redirect: to => ({
            name: 'portfolio-generator-generation',
            params: { generationId: to.params.generationId },
            query: to.query,
            hash: to.hash
        })
    },
    {
        path:'/admin/preview/:shortId',
        name: 'admin-portfolio-preview',
        component: PortfolioWrapper,
        meta: {
            type: 'view',
            requiresAdmin: true,
            adminPreview: true,
        },
    },
    {
        path:'/admin/preview/p/:portfolioShortId/:projectShortId',
        name: 'admin-case-study-preview',
        component: PageWrapper,
        meta: {
            type: 'view',
            requiresAdmin: true,
            adminPreview: true,
        },
    },
    {
        path:'/admin',
        name:'adminPage',
        type: 'landing',
        meta: {
            requiresAdmin: true,
            title: 'UXfolio - Admin'
        },
        component: AdminSite,
        redirect: { name: 'admin-users' },
        children: [
            {
                path: 'users',
                name: 'admin-users',
                component: AdminUsers,
                meta: { adminGroup: 'Core', adminLabel: 'Users', adminContainer: 'fw' }
            },
            {
                path: 'subscriptions',
                name: 'admin-subscriptions',
                component: AdminSubscriptionReport,
                meta: { adminGroup: 'Core', adminLabel: 'Subscriptions', adminContainer: 'narrow' }
            },
            {
                path: 'cancel-reasons',
                name: 'admin-cancel-reasons',
                component: AdminCancelReason,
                meta: { adminGroup: 'Core', adminLabel: 'Cancel reasons', adminContainer: 'narrow' }
            },
            {
                path: 'survey-responses',
                name: 'admin-survey-responses',
                component: AdminSurveyResponses,
                meta: { adminGroup: 'Core', adminLabel: 'Survey responses', adminContainer: 'fw' }
            },
            {
                path: 'showcase',
                name: 'admin-showcase',
                component: AdminShowcase,
                meta: { adminGroup: 'Content', adminLabel: 'Showcase', adminContainer: 'fw' }
            },
            {
                path: 'user-reviews',
                name: 'admin-reviews',
                component: AdminReviews,
                meta: { adminGroup: 'Content', adminLabel: 'User reviews', adminContainer: 'fw' }
            },
            {
                path: 'background-library',
                name: 'admin-background-library',
                component: AdminBackgroundLibrary,
                meta: { adminGroup: 'Content', adminLabel: 'Background Library', adminContainer: 'fw' }
            },
            {
                path: 'color-palettes',
                name: 'admin-color-palettes',
                component: AdminColorPalettes,
                meta: { adminGroup: 'Content', adminLabel: 'Color palettes', adminContainer: 'fw' }
            },
            {
                path: 'section-preset-groups',
                name: 'admin-section-preset-groups',
                component: AdminSectionPresetGroups,
                meta: { adminGroup: 'Content', adminLabel: 'Section preset groups', adminContainer: 'fw' }
            },
            {
                path: 'own-domain',
                name: 'admin-own-domain',
                component: AdminOwnDomain,
                meta: { adminGroup: 'Operations', adminLabel: 'Own domain', adminContainer: 'narrow' }
            },
            {
                path: 'system-notifications',
                name: 'admin-system-notifications',
                component: AdminSystemNotifications,
                meta: { adminGroup: 'Operations', adminLabel: 'System notifications', adminContainer: 'fw' }
            },
            {
                path: 'emergency-banner',
                name: 'admin-emergency-banner',
                component: AdminEmergencyBanner,
                meta: { adminGroup: 'Operations', adminLabel: 'Emergency banner', adminContainer: 'narrow' }
            },
            {
                path: 'referrals',
                name: 'admin-referrals',
                component: AdminReferals,
                meta: { adminGroup: 'Growth', adminLabel: 'Referrals', adminContainer: 'fw' }
            },
            {
                path: 'ai-settings',
                name: 'admin-ai-settings',
                component: AdminAiSettings,
                meta: { adminGroup: 'AI & Safety', adminLabel: 'AI settings', adminContainer: 'fw' }
            },
            {
                path: 'spam-deletion',
                name: 'admin-spam-deletion',
                component: AdminSpamDeletion,
                meta: { adminGroup: 'AI & Safety', adminLabel: 'Spam deletion', adminContainer: 'fw' }
            },
            {
                path: 'ai-generation-traces',
                name: 'admin-ai-generation-traces',
                component: AdminAiGenerationTraces,
                meta: { adminGroup: 'AI & Safety', adminLabel: 'AI Generation Traces', adminContainer: 'fw' }
            }
        ]
    },
    //Settings
    {
        path: '/settings',
        name: 'settingsEditorApp',
        meta: {
            requiresAdmin: true,
            title: 'UXfolio - Settings'
        },
        component: SettingsEditor,
        redirect: {
            name:'copy'
        },
        children: [
            {
                name:'copy',
                path: 'copy',
                component: CopySettings,
            },
            {
                name:'image-ideas',
                path: 'image-ideas',
                component: ImageIdeasSettings
            },
            {
                name:'fonts',
                path:'fonts',
                component: EditFontView
            },
            {
                name:'survey-modal-settings',
                path:'survey-modal-settings',
                component: EditSurveyModalSettings
            },
            {
                name:'spam-filter-settings',
                path:'spam-filter-settings',
                component: SpamFilterSettings
            }
        ]
    },
];

const editorRoutes = [
    {
        path: '/home',
        name: 'HomePageEditorApp',
        meta: {
            title: 'Editor - UXfolio'
        },
        component: PortfolioEditor,
        children: [
            {
                path: 'portfolios',
                component: PortfolioManagerPage,
                props: true,
                meta: {
                    title: 'Portfolio manager - UXfolio',
                    nonEditorPage: true
                },
                children: [
                    {
                        path: '',
                        name: 'Portfolio manager - UXfolio',
                        component: PortfoliosList,
                        props: true
                    },
                    {
                        path: 'create-new-portfolio',
                        component: TemplateList,
                        props: true
                    },
                    {
                        path: 'create-new-portfolio/template-preview',
                        component: TemplatePreview,
                        props: true
                    },
                    {
                        path: 'create-new-portfolio/select-projects',
                        component: AllProjectsList,
                        props: true
                    },
                ]
            },
            {
                path: 'portfolios/:portfolioId',
                name: 'Home Page Editor',
                component: HomePage,
                alias: 'portfolios/:portfolioId/style',
                meta: {
                    title: 'Editor - UXfolio'
                },
                children: [
                    designPanelRoutes,
                    settingsPanelRoutes,
                    pagesPanelRoutes
                ]
            },
            {
                path: 'portfolios/:portfolioId/about',
                component: AboutPage,
                children: [
                    designPanelRoutes,
                    settingsPanelRoutes,
                    pagesPanelRoutes
                ]
            },
            {
                path: 'portfolios/:portfolioId/contact',
                component: ContactPage,
                children: [
                    designPanelRoutes,
                    settingsPanelRoutes,
                    pagesPanelRoutes
                ]
            },
            {
                path: 'portfolios/:portfolioId/p/:projectShortId',
                component: CustomPage,
                children: [
                    designPanelRoutes,
                    settingsPanelRoutes,
                    pagesPanelRoutes
                ]
            },
            {
                path: 'onboarding',
                components: {onBoarding: OnBoardingPage},
                props: true,
                meta: {
                    title: 'Onboarding - UXfolio',
                    nonEditorPage: true,
                },
                children: [
                    {
                        path: '',
                        component: TemplateList,
                        props: true
                    },
                    {
                        path: 'template-preview',
                        component: OnboardingTemplatePreview,
                        props: true
                    },
                ]
            },
            {
                path: 'settings',
                name: 'Account Settings',
                redirect: { path: "/home/settings/account-settings" },
                component:AccountSettingsPage,
                props: true,
                meta: {
                    title: 'Account - UXfolio',
                    nonEditorPage: true,
                },
                children:[
                    {
                        path: 'account-settings',
                        name: 'Account settings',
                        components: {accountSettingsSubView: AccountSettingsSubPage},
                    },
                    {
                        path: 'domains',
                        name: 'Domains',
                        components: {accountSettingsSubView: DomainsSubPage},
                    },
                    {
                        path: 'plan-and-payment',
                        name: 'Plan and payment',
                        components: {accountSettingsSubView: PlanAndPaymentSubPage},
                    },
                    {
                        path: 'portfolio-settings',
                        name: 'Portfolio settings',
                        components: {accountSettingsSubView: PortfolioSettingsSubPage},
                    }
                ]
            },
            {
                path: 'notifications',
                name: 'Notifications',
                component: NotificationsPage,
                props: true,
                meta: {
                    title: 'Notifications - UXfolio',
                    nonEditorPage: true,
                },
            },
            {
                path: 'prices',
                name: 'Prices',
                component: Prices,
                props: true,
                meta: {
                    title: 'Prices - UXfolio',
                    nonEditorPage: true,
                },
            },
            {
                path: 'payment',
                name: 'Payment Center',
                component: PaymentCenter,
                props: true,
                meta: {
                    title: 'Payment - UXfolio',
                    nonEditorPage: true,
                },
                children:[
                    {
                        path: '',
                        name: 'Payment',
                        component: PaymentApp,
                        props: (route) => ({
                            ...route.params
                        })
                    },
                    {
                        path: 'auth',
                        name: 'Auth',
                        component: PaymentSecondaryAuth,
                        props: true
                    },
                    {
                        path: 'success',
                        name: 'Success',
                        component: PaymentSuccess,
                        props: true
                    },
                    {
                        path: 'failure',
                        name: 'Failure',
                        component: PaymentFailure,
                        props: true
                    },
                    {
                        path: 'deleted',
                        name: 'Deleted',
                        component: CardDeleted,
                        props: true
                    },
                ]
            },
            {
                path: 'domain',
                name: 'Domain center',
                component: DomainCenter,
                props: true,
                meta: {
                    title: 'Domain editor - Uxfolio',
                    nonEditorPage: true,
                },
                children: [
                    {
                        path: 'manage',
                        name: 'Domain manager',
                        component: DomainApp,
                        props: true

                    },
                    {
                        path: 'search',
                        name: 'Domain search',
                        component: DomainSearch,
                        props: true
                    },

                    {
                        path: 'connect',
                        name: 'Connect domain',
                        component: ConnectDomain,
                        props: true
                    },
                    {
                        path: 'transfer',
                        name: 'Transfer domain',
                        component: DomainTransfer,
                        props: true
                    },
                ]
            },
            {
                path: 'url',
                name: 'Url center',
                component: UrlCenter,
                props: true,
                meta: {
                    title: 'URL editor - Uxfolio',
                    nonEditorPage: true,
                },
                children: [
                    {
                        path: 'edit',
                        name: 'Edit url',
                        component: EditUrl,
                        props: true,
                    }
                ]
            },
        ]
    },
    {
        path: "/:catchAll(.*)",
        name: "NotFound",
        component: NotFound
    },
    {
        path: '/projects/*',
        name: "LegacyProjectEditUrl",
        component: NotFound
    }
];

const routes = [
    ...projectRouters,
    ...portfolioGenerationPreviewRoutes,
    ...ownerPreviewRoutes,
    ...globalAndAdminRoutes,
    ...portfolioRouters.filter(r => r.path !== '/:shortId'),
    ...editorRoutes,
    ...reviewRoutes,
    ...jfcRoutes,
    {
        path: '/:shortId',
        component: PortfolioWrapper,
        meta: { type: 'view' }
    }
];

let MainRouter;

export default MainRouter = VueRouter.createRouter({
    history:VueRouter.createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        let pathArray = to.path.split('/');
        if (to.hash) {
            return {
                el: to.hash,
                behavior: 'smooth',
            }
        }
        if(!pathArray.includes('home') && pathArray.includes('p') && to.meta.type !== 'view') {
            // always scroll to top if not in editor
            return { top: 0 }
        }
        if (to.meta.type === 'landing') {
            return { top: 0 }
        }
        if (pathArray.includes('prices')) {
            return  { top: 0 }
        }
    },
})

MainRouter.beforeEach((to, from, next) => {
    let pathArray = to.path.split('/');

    if((pathArray.includes('home') && !pathArray.includes('p')) || to.meta.type === 'landing') {
        document.title = to.meta.title || 'UXfolio - Build the UX portfolio that gets you hired';
    }
    next();
});

//If we are already on the review route keep the logic.
MainRouter.beforeEach((to, from, next) => {
    if (from.path.startsWith('/review') && !to.path.startsWith('/review')) {
        next(`/review${to.path}`);
    }
    else if (from.path.startsWith('/myreviews') && !to.path.startsWith('/myreviews')) {
        next(`/myreviews${to.path}`);
    }
    else {
        next();
    }
});

//If we are already on the JFC route keep the logic.
MainRouter.beforeEach((to, from, next) => {
    if (
        from.path.startsWith('/jobfitchecker') &&
        !to.path.startsWith('/jobfitchecker') &&
        !to.query.skipJfc
    ) {
        next(`/jobfitchecker${to.path}`);
    } else {
        next();
    }
});

//Keep links inside the owner's draft preview on the preview routes.
MainRouter.beforeEach((to, from, next) => {
    if (!from.meta?.ownerPreview || to.meta?.ownerPreview || to.meta?.type !== 'view') {
        return next();
    }

    const previewRoute = MainRouter.resolve(`/preview${to.fullPath}`);
    if (previewRoute.meta?.ownerPreview) {
        return next(previewRoute.fullPath);
    }
    next();
});

MainRouter.beforeEach((to, from, next) => {
    const cameFromPreview = from.query.templatePreview === 'true';
    if (cameFromPreview && to.query.templatePreview !== 'true') {
        return next({
            ...to,
            query: { ...to.query, templatePreview: 'true' },
            replace: true
        });
    }
    next();
});

MainRouter.beforeEach(async (to, from, next) => {
    if (!requiresAuthentication(to.path)) {
        return next();
    }

    if (keycloak.authenticated) {
        return next();
    }

    if (isAuthCallbackUrl(to.fullPath, window.location.hash)) {
        const authenticated = await initAuth();

        if (authenticated || keycloak.authenticated) {
            const cleanRedirectUri = sanitizeAuthRedirect(window.location.href);

            if (cleanRedirectUri !== window.location.href) {
                // window.history.replaceState() doesn't reliably remove hash fragments
                // in all browsers (especially Firefox). We need to force a navigation.
                // Using window.location.replace() ensures the hash is completely removed
                // from the browser's history and address bar.
                window.location.replace(cleanRedirectUri);
                return next(false);
            }
            return next();
        }

        const cleanRedirectUri = sanitizeAuthRedirect(window.location.href);
        window.history.replaceState({}, document.title, cleanRedirectUri);
        await resetAuthState();
        try {
            await login(cleanRedirectUri);
            return next(false);
        } catch (error) {
            publishAuthStatus({
                state: 'auth_callback_failed',
                title: 'We could not complete sign in',
                message: 'Something interrupted the secure login callback. You can try again without losing your work.',
                primaryLabel: 'Try again',
                primaryAction: 'forceLogin',
                secondaryLabel: 'Reload page',
                secondaryAction: 'retry',
                redirectUri: cleanRedirectUri,
            });
            return next(false);
        }
    }

    try {
        if (!keycloak.authenticated) {
            await initAuth();
        }
        
        if (keycloak.authenticated) {
            return next();
        }

        if (getLastAuthCheckResult().status === 'error') {
            return next(false);
        }

        await login(`${window.location.origin}${to.fullPath}`);
        return next(false);
    } catch (error) {
        publishAuthStatus({
            state: 'auth_route_guard_failed',
            title: 'We could not check your session',
            message: 'Your work is still safe. You can reload the page or open secure login again.',
            primaryLabel: 'Reload page',
            primaryAction: 'retry',
            secondaryLabel: 'Open login',
            secondaryAction: 'forceLogin',
            redirectUri: `${window.location.origin}${to.fullPath}`,
        });
        return next(false);
    }
});

MainRouter.beforeEach((to, from, next) => requireAdminAccess(to, next));
